import script from "./checkList.vue?vue&type=script&setup=true&lang=js"
export * from "./checkList.vue?vue&type=script&setup=true&lang=js"

import "./checkList.vue?vue&type=style&index=0&id=576bfd04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576bfd04"]])

export default __exports__